'use strict';

/*----------------------------
URL Select
---
Refresh a page using a url value from a select dropdown.
----------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  var urlSelects = document.querySelectorAll('.url-select');

  Array.from(urlSelects).forEach(function (select) {
    select.addEventListener('change', function () {
      // URL
      var url = select.value;

      // Reload the page.
      window.top.location.href = url;
    });
  });
});